import { Injectable } from '@angular/core';
import { TriggerRuleFilters } from "../model/filters/trigger-rule-filters";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { HttpClient } from "@angular/common/http";
import { TriggerPersistRequest } from "../model/requests/trigger-persist-request";
import { TriggerRulePersistRequest } from "../model/requests/trigger-rule-persist-request";

@Injectable({
  providedIn: 'root'
})
export class TriggerRulesService {

  private readonly triggerRulesURL: string;

  constructor(private http: HttpClient) {
    this.triggerRulesURL = "/catalog/trigger_rules";
  }

  public getTriggerRules(offset?: number, limit?: number, filters?: TriggerRuleFilters): Observable<any>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new TriggerRuleFilters();
    return this.http.post<any>(this.triggerRulesURL, body, options);
  }

  public createTriggerRule(persistData: TriggerRulePersistRequest) {
    let url = `${this.triggerRulesURL}/create`;
    return this.http.post<any>(url, persistData);
  }

  public editTriggerRule(persistData: TriggerRulePersistRequest) {
    let url = `${this.triggerRulesURL}/edit`;
    return this.http.post<any>(url, persistData);
  }

  public deleteTriggerRules(identifiers: {tenantUuid: string, organizationUuid: string, name: string}[]) {
    let url = `${this.triggerRulesURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
